import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useMemo } from 'react';
import { getNormalizedViewingPercentage } from '../utils/timeSpentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TimeSpentViewingBar({
  backgroundColor,
  isEmptyState,
  percentage,
  percentageDifference,
  title,
  tooltip
}) {
  const normalizedViewingPercentage = useMemo(() => getNormalizedViewingPercentage(percentage, percentageDifference), [percentage, percentageDifference]);
  if (percentage === 0 && !isEmptyState) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: "1",
    flexDirection: "column",
    inlineSize: `${normalizedViewingPercentage}%`,
    children: [/*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx("span", {
        children: title
      }), !isEmptyState && /*#__PURE__*/_jsx(Tooltip, {
        headingText: title,
        placement: "bottom",
        title: tooltip,
        children: /*#__PURE__*/_jsx(IconHolder, {
          marginInlineStart: "200",
          color: "do-not-use-eerie",
          icon: InfoIcon,
          size: "300"
        })
      })]
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "body-300",
      children: I18n.formatPercentage(percentage, {
        precision: 2
      })
    }), /*#__PURE__*/_jsx(View, {
      blockSize: "25px",
      inlineSize: "100%",
      backgroundColor: backgroundColor
    })]
  });
}